export default __webpack_public_path__ + "static/media/2009.77d78cee.png";